
//import Clases from "./Clases.js";
const Clases = require("./Clases.js");
const axios = require("axios");
//const _SincronizacionCorriendo = false;

module.exports.MiIP = async () => {
  var _Retorno = "";
  await axios
            .get("https://api.ipify.org/?format=json")
            .then(function (r) {
                //console.log(r);
                _Retorno = r.data.ip;
                //_This.$parent.Notificacion("Registro guardado!", "También ha quedado correctamente sincronizado con el servidor.", "success", 8);
            })
            .catch(function (error) {

            });
  return _Retorno;
}

module.exports.IniciarProcesoSincronizaciones = (_AppVue) => {
    //if (!_SincronizacionCorriendo){
        //_SincronizacionCorriendo = true;
        console.log(this._KeyRegistrosPendientesGeneralPluviometros);
        //_AppVue.Notificacion("hola", "", "", 3);

        console.log("Inicio ProcesoCargasPendientes...");
        setTimeout(() => {
            this.ProcesoCargasPendientes(_AppVue)
          }, 2000);
    //}
}

module.exports.ProcesoCargasPendientes = async(_AppVue) => {
    try {
      if (_AppVue.Datos.AppOnline()){
        ActualizacionRegistrosPluviometros(_AppVue);
        ActualizacionRegistrosFreatimetros(_AppVue);
      }

      //Vuelvo a llamar la funcion
      setTimeout(() => {
        this.ProcesoCargasPendientes(_AppVue)
      }, 2000);

    } catch (e) {
      console.log(e);
    }
}

//#region "Funciones PLUVIOMETROS"
var _KeyDataCacheadaPluviometros = "InfoPluviometro";
module.exports.KeyDataCacheadaPluviometros = (_IdPluviometro) => {
  return _KeyDataCacheadaPluviometros + _IdPluviometro;
}
module.exports.GuardarDataEnCachePluviometro = (_InfoAGuardar) => {
  var _Data = {
    _Fecha: new Clases.Fecha(new Date()),
    _Key: "InfoPluviometro" + _InfoAGuardar._IdPluviometro,
    _Json: _InfoAGuardar
  };
  Clases.GuardarJsonEnStorage(this.KeyDataCacheadaPluviometros(_InfoAGuardar._IdPluviometro), _Data);
}

module.exports._KeyRegistrosPendientesGeneralPluviometros = "RegistrosPendientes_Pluviometros_";
ActualizacionRegistrosPluviometros = async(_AppVue) => {
    try {
        //console.log(_AppVue.$children);
        // console.log(Vue.$options.components["SeccionPluviometro"]);
        var _ArchivosSincronizados = 0;
        var _Pendientes = Clases.RecuperarJsonsDeStorage(this._KeyRegistrosPendientesGeneralPluviometros);
        for (let index = 0; index < _Pendientes.length; index++){
            var _Registros = _Pendientes[index];
            var _RegistrosAux = [];
            var _HuboActualizaciones = false;
            var _IdPluviometro = 0;
            for (let index = 0; index < _Registros.length; index++){
                let _Reg = _Registros[index];
                _IdPluviometro = _Reg.IdPluviometro;
                var _Par = {
                    IdUsuario: _AppVue.Datos._User._ID,
                    IdPluviometro: _Reg.IdPluviometro,
                    Valor: _Reg.Valor,
                    Fecha: _Reg.Fecha
                };
                let _Retorno = await this.IntentoAltaRegistroPluviometro(_Par, false, _AppVue);
                if(_Retorno){
                    _HuboActualizaciones = true;
                    _ArchivosSincronizados += 1;
                }else{
                    _RegistrosAux.push(_Reg);
                }
            }
            if(_HuboActualizaciones){
              Clases.GuardarJsonEnStorage(this._KeyRegistrosPendientesGeneralPluviometros + _IdPluviometro, _RegistrosAux);
              ActualizarComponentePluviometro(_AppVue, _IdPluviometro);
              console.log("RegistrosPluviometros sincronizados!");
            }
        }

        if(_ArchivosSincronizados > 0){
          _AppVue.Notificacion(_ArchivosSincronizados + " registros de pluviómetro sincronizados!", "", "", 3);
        }
    } catch (error) {
        console.log(error);
    }
}
module.exports.IntentoAltaRegistroPluviometro = async (_Par, _AgregoPendienteSiFalla, _AppVue) => {
    var _Retorno = false;
    try {
        var _This = this;
        await axios
            .post(process.env.VUE_APP_API_URL + "/AgroIdeas/AltaRegistroPluviometro", _Par)
            .then(function (response) {
                _Retorno = true;
                //_This.$parent.Notificacion("Registro guardado!", "También ha quedado correctamente sincronizado con el servidor.", "success", 8);
            })
            .catch(function (error) {
                if(_AgregoPendienteSiFalla){
                    var _Key = _This._KeyRegistrosPendientesGeneralPluviometros + _Par.IdPluviometro;
                    var _Pendientes = Clases.RecuperarJsonDeStorage(_Key);
                    if(_Pendientes == null){ _Pendientes = []; }
                    _Pendientes.push(_Par);
                    Clases.GuardarJsonEnStorage(_Key, _Pendientes);
                    //this.ActualizarComponentePluviometro(_AppVue, _Par.IdPluviometro);
                    _AppVue.Notificacion("Registro guardado!", "Se sincronizará automáticamente con el servidor cuando vuelvas a tener conexión.", "warn", 8);
                }
            })
            .then(function () {
            });
    } catch (error) {
        console.log(error);
    }
    return _Retorno;
}
module.exports.ObtenerRegistrosPluviometro = (_Id, _Componente) => {
  var _MD = this;
    try {
      axios
        .post(
            process.env.VUE_APP_API_URL + "/AgroIdeas/RegistrosPluviometro",
            {
                IdPluviometro: _Id
            }
        )
        .then(function (response) {
          _MD.GuardarDataEnCachePluviometro(response.data);
          if(_Componente){
            if (_Componente.VistaActual(_Id)){
              _Componente.InfoPluviometro = response.data;
              _Componente.DataActualizada = true;
              _Componente.AuxiliaresVista(_Id);
            }
          }
        })
        .catch(function (error) {
          if(_Componente){
            if (_Componente.VistaActual(_Id)){
              _Componente.DataActualizada = false;
              _Componente.AuxiliaresVista(_Id);
            }
          }
        })
        .then(function () {});
    } catch (error) {
      console.log(error);
    }
}
ActualizarComponentePluviometro = (_AppVue, _IdPluviometro) => {
  try {
      let _Componente = _AppVue.$children.find(child => { return child.$options.name === "Pluviometro"; });
      this.ObtenerRegistrosPluviometro(_IdPluviometro, _Componente);
  } catch (error) {
    console.log(error);
  }
}
module.exports.UpdateRegistroPluviometro = async (_Registro, _AppVue) => {
  var _Retorno = false;
  try {
      var _This = this;
      await axios
          .patch(process.env.VUE_APP_API_URL + "/AgroIdeas/EditarRegistroPluviometro", _Registro)
          .then(function (response) {
              _Retorno = true;
              //_This.$parent.Notificacion("Registro guardado!", "También ha quedado correctamente sincronizado con el servidor.", "success", 8);
          })
          .catch(function (error) {
              console.error(error);
          })
          .then(function () {
          });
  } catch (error) {
      console.log(error);
  }
  return _Retorno;
}
//#endregion

//#region "Funciones FREATIMETROS"
var _KeyDataCacheadaFreatimetros = "InfoFreatimetro";
module.exports.KeyDataCacheadaFreatimetros = (_IdFreatimetro) => {
  return _KeyDataCacheadaFreatimetros + _IdFreatimetro;
}
module.exports.GuardarDataEnCacheFreatimetro = (_InfoAGuardar) => {
  var _Data = {
    _Fecha: new Clases.Fecha(new Date()),
    _Key: "InfoFreatimetro" + _InfoAGuardar._IdFreatimetro,
    _Json: _InfoAGuardar
  };
  Clases.GuardarJsonEnStorage(this.KeyDataCacheadaFreatimetros(_InfoAGuardar._IdFreatimetro), _Data);
}

module.exports._KeyRegistrosPendientesGeneralFreatimetros = "RegistrosPendientes_Freatimetros_";
ActualizacionRegistrosFreatimetros = async(_AppVue) => {
    try {
        var _ArchivosSincronizados = 0;
        var _Pendientes = Clases.RecuperarJsonsDeStorage(this._KeyRegistrosPendientesGeneralFreatimetros);
        for (let index = 0; index < _Pendientes.length; index++){
            var _Registros = _Pendientes[index];
            var _RegistrosAux = [];
            var _HuboActualizaciones = false;
            var _IdFreatimetro = 0;
            for (let index = 0; index < _Registros.length; index++){
                let _Reg = _Registros[index];
                _IdFreatimetro = _Reg.IdFreatimetro;
                var _Par = {
                    IdUsuario: _AppVue.Datos._User._ID,
                    IdFreatimetro: _Reg.IdFreatimetro,
                    Valor: _Reg.Valor,
                    Fecha: _Reg.Fecha
                };
                let _Retorno = await this.IntentoAltaRegistroFreatimetro(_Par, false, _AppVue);
                if(_Retorno){
                    _HuboActualizaciones = true;
                    _ArchivosSincronizados += 1;
                }else{
                    _RegistrosAux.push(_Reg);
                }
            }
            if(_HuboActualizaciones){
              Clases.GuardarJsonEnStorage(this._KeyRegistrosPendientesGeneralFreatimetros + _IdFreatimetro, _RegistrosAux);
              ActualizarComponenteFreatimetro(_AppVue, _IdFreatimetro);
              console.log("RegistrosFreatimetros sincronizados!");
            }
        }

        if(_ArchivosSincronizados > 0){
          _AppVue.Notificacion(_ArchivosSincronizados + " registros de freatímetro sincronizados!", "", "", 3);
        }
    } catch (error) {
        console.log(error);
    }
}
module.exports.IntentoAltaRegistroFreatimetro = async (_Par, _AgregoPendienteSiFalla, _AppVue) => {
    var _Retorno = false;
    try {
        var _This = this;
        await axios
            .post(process.env.VUE_APP_API_URL + "/AgroIdeas/AltaRegistroFreatimetro", _Par)
            .then(function (response) {
                _Retorno = true;
            })
            .catch(function (error) {
                if(_AgregoPendienteSiFalla){
                    var _Key = _This._KeyRegistrosPendientesGeneralFreatimetros + _Par.IdFreatimetro;
                    var _Pendientes = Clases.RecuperarJsonDeStorage(_Key);
                    if(_Pendientes == null){ _Pendientes = []; }
                    _Pendientes.push(_Par);
                    Clases.GuardarJsonEnStorage(_Key, _Pendientes);
                    _AppVue.Notificacion("Registro guardado!", "Se sincronizará automáticamente con el servidor cuando vuelvas a tener conexión.", "warn", 8);
                }
            })
            .then(function () {
            });
    } catch (error) {
        console.log(error);
    }
    return _Retorno;
}
module.exports.ObtenerRegistrosFreatimetro = (_Id, _Componente) => {
  var _MD = this;
    try {
      axios
        .post(
            process.env.VUE_APP_API_URL + "/AgroIdeas/RegistrosFreatimetro",
            {
                IdFreatimetro: _Id,
            }
        )
        .then(function (response) {
          _MD.GuardarDataEnCacheFreatimetro(response.data);
          if(_Componente){
            if (_Componente.VistaActual(_Id)){
              _Componente.InfoFreatimetro = response.data;
              _Componente.DataActualizada = true;
              _Componente.AuxiliaresVista(_Id);
            }
          }
        })
        .catch(function (error) {
          if(_Componente){
            if (_Componente.VistaActual(_Id)){
              _Componente.DataActualizada = false;
              _Componente.AuxiliaresVista(_Id);
            }
          }
        })
        .then(function () {});
    } catch (error) {
      console.log(error);
    }
}
ActualizarComponenteFreatimetro = (_AppVue, _IdFreatimetro) => {
  try {
      let _Componente = _AppVue.$children.find(child => { return child.$options.name === "Freatimetro"; });
      this.ObtenerRegistrosFreatimetro(_IdFreatimetro, _Componente);
  } catch (error) {
    console.log(error);
  }
}

module.exports.UpdateRegistroFreatimetro = async (_Registro, _AppVue) => {
  var _Retorno = false;
  try {
      var _This = this;
      await axios
          .patch(process.env.VUE_APP_API_URL + "/AgroIdeas/EditarRegistroFreatimetro", _Registro)
          .then(function (response) {
              _Retorno = true;
              //_This.$parent.Notificacion("Registro guardado!", "También ha quedado correctamente sincronizado con el servidor.", "success", 8);
          })
          .catch(function (error) {
              console.error(error);
          })
          .then(function () {
          });
  } catch (error) {
      console.log(error);
  }
  return _Retorno;
}
//#endregion

//#region "Funciones VERIS"
module.exports._KeyRegistrosPendientesGeneralVeris = "RegistrosPendientes_Veris_";

module.exports.IntentoAltaRegistroVeris = async (_Par, _AgregoPendienteSiFalla, _AppVue) => {
    var _Retorno = false;
    try {
        var _This = this;
        await axios
        .post(process.env.VUE_APP_API_URL + "/uploadpdf", _Par)
        .then((data) => {
            _Retorno = true;
        })
        .catch(function (error) {
            if(error.toString().includes("Network Error")){
                _AppVue.Notificacion("Network Error!", "Hubo un problema de conexión, intenta nuevamente cuando recuperes el internet!", "error", 8);
            }else{
                _AppVue.Notificacion("Error!", "Consulta con algún administrador!", "error", 8);
            }
            console.log(error);
            // if(_AgregoPendienteSiFalla){
            //     var _Key = _This._KeyRegistrosPendientesGeneralVeris + _Par.IdVeris;
            //     var _Pendientes = Clases.RecuperarJsonDeStorage(_Key);
            //     if(_Pendientes == null){ _Pendientes = []; }
            //     _Pendientes.push(_Par);
            //     Clases.GuardarJsonEnStorage(_Key, _Pendientes);
            //     _AppVue.Notificacion("Registro guardado!", "Se sincronizará automáticamente con el servidor cuando vuelvas a tener conexión.", "warn", 8);
            // }
        });
    } catch (error) {
        console.log(error);
    }
    return _Retorno;
}
module.exports.ObtenerRegistrosVeris = (_Id, _Componente) => {
    var _This = _Componente;
    try {
      axios
        .post(
            process.env.VUE_APP_API_URL + "/AgroIdeas/RegistrosVeris",
            {
                Id: _Id,
            }
        )
        .then(function (response) {
          _This.GuardarDataEnCache(response.data);
          if (_This.VistaActual(_Id)){
            _This.InfoVeris = response.data;
            _This.DataActualizada = true;
            _This.AuxiliaresVista(_Id);
          }
        })
        .catch(function (error) {
          if (_This.VistaActual(_Id)){
            _This.DataActualizada = false;
            _This.AuxiliaresVista(_Id);
          }
        })
        .then(function () {});
    } catch (error) {
      console.log(error);
    }
}
//#endregion

//#region "Funciones Análisis Agua"
module.exports.IntentoAltaRegistroAgua = async (_Par, _AgregoPendienteSiFalla, _AppVue) => {
    var _Retorno = false;
    try {
        var _This = this;
        await axios
        .post(process.env.VUE_APP_API_URL + "/uploadpdf", _Par)
        .then((data) => {
            console.log(data);
            _Retorno = true;
        })
        .catch(function (error) {
            if(error.toString().includes("Network Error")){
                _AppVue.Notificacion("Network Error!", "Hubo un problema de conexión, intenta nuevamente cuando recuperes el internet!", "error", 8);
            }else{
                _AppVue.Notificacion("Error!", "Consulta con algún administrador!", "error", 8);
            }
            console.log(error);
        });
    } catch (error) {
        console.log(error);
    }
    return _Retorno;
}
module.exports.ObtenerRegistrosAgua = (_Id, _Componente) => {
    var _This = _Componente;
    try {
      axios
        .post(
            process.env.VUE_APP_API_URL + "/AgroIdeas/RegistrosAgua",
            {
                Id: _Id,
            }
        )
        .then(function (response) {
          _This.GuardarDataEnCache(response.data);
          if (_This.VistaActual(_Id)){
            _This.Info = response.data;
            _This.DataActualizada = true;
            _This.AuxiliaresVista(_Id);
          }
        })
        .catch(function (error) {
          if (_This.VistaActual(_Id)){
            _This.DataActualizada = false;
            _This.AuxiliaresVista(_Id);
          }
        })
        .then(function () {});
    } catch (error) {
      console.log(error);
    }
}
//#endregion

//#region "Funciones Análisis Suelo"
module.exports.IntentoAltaRegistroSuelo = async (_Par, _AgregoPendienteSiFalla, _AppVue) => {
  var _Retorno = false;
  try {
      var _This = this;
      await axios
      .post(process.env.VUE_APP_API_URL + "/uploadpdf", _Par)
      .then((data) => {
          console.log(data);
          _Retorno = true;
      })
      .catch(function (error) {
          if(error.toString().includes("Network Error")){
              _AppVue.Notificacion("Network Error!", "Hubo un problema de conexión, intenta nuevamente cuando recuperes el internet!", "error", 8);
          }else{
              _AppVue.Notificacion("Error!", "Consulta con algún administrador!", "error", 8);
          }
          console.log(error);
      });
  } catch (error) {
      console.log(error);
  }
  return _Retorno;
}
module.exports.ObtenerRegistrosSuelo = (_Id, _Componente) => {
  var _This = _Componente;
  try {
    axios
      .post(process.env.VUE_APP_API_URL + "/AgroIdeas/RegistrosSuelo",
          {
              Id: _Id,
          }
      )
      .then(function (response) {
        _This.GuardarDataEnCache(response.data);
        if (_This.VistaActual(_Id)){
          _This.Info = response.data;
          _This.DataActualizada = true;
          _This.AuxiliaresVista(_Id);
        }
      })
      .catch(function (error) {
        if (_This.VistaActual(_Id)){
          _This.DataActualizada = false;
          _This.AuxiliaresVista(_Id);
        }
      })
      .then(function () {});
  } catch (error) {
    console.log(error);
  }
}
//#endregion

//#region "VARIAS"
module.exports.DescargarArchivo = async(_Url) => {
  return axios.get(_Url, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

module.exports.GetRegistrosHerramienta = async (idHerramientaEstablecimiento, _Componente) => {
  var result = null;
  try {
    let userLogged = Clases.GetUserLogged();
    if (userLogged == null) return false; //TODO: Redirigir al login

    await axios
      .get(`${process.env.VUE_APP_API_URL}/AgroIdeas/GetRegistrosHerramienta/${userLogged._ID}/${idHerramientaEstablecimiento}`)
      .then(function (response) {
        result = response.data;
        //_This.GuardarDataEnCache(response.data);
        //_This.RefreshMe(response.data, idHerramientaEstablecimiento);

      })
      .catch(function (error) {
        console.log(error);
        //_This.RefreshMe(null, idHerramientaEstablecimiento);
      });
  } catch (error) {
    console.log(error);
  }
  return result;
}


module.exports.TryAddRegistroHerramientaEstablecimiento = async (_Par, _AppVue) => {
  var result = null;
  try {
      await axios
      .post(process.env.VUE_APP_API_URL + "/AgroIdeas/uploadpdf", _Par)
      .then((data) => {
          result = data;
      })
      .catch(function (error) {
        console.log(error);
          if(error.toString().includes("Network Error")){
              _AppVue.Notificacion("Network Error!", "Hubo un problema de conexión, intenta nuevamente cuando recuperes el internet!", "error", 8);
          }else{
              _AppVue.Notificacion("Error!", "Consulta con algún administrador!", "error", 8);
          }
          console.log(error);
      });
  } catch (error) {
      console.log(error);
  }
  return result;
}
//#endregion

